import React, { useState, useEffect, useContext, useRef } from "react";
import AdminContext from "../../StateContext/Application";
import { Form, Link, redirect, useNavigate, useParams } from "react-router-dom";
import { apiurl } from "../../../../path";
import "./grdraftreceipt.css";
import "./GrDraftList.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import ReactDOMServer from "react-dom/server";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../styles/GooglePagination";
import { formatDateTime, formatDate, formatIndianAmount } from '../../../../utils/DateFormat';
const headerStyle = {
  padding: "12px 16px",
  whiteSpace: "nowrap",
  borderRight: "1px solid #e0e0e0",
};

// const EditableBlock = ({ children, onEdit }) => (
//     <div
//         contentEditable={true}
//         suppressContentEditableWarning={true}
//         style={{ outline: "1px dashed gray", padding: "4px", marginBottom: "10px" }}
//         onInput={(e) => {
//             let text = e.currentTarget.innerText;

//             // ❌ remove emojis
//             text = text.replace(
//                 /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
//                 ""
//             );

//             // update content if emoji was entered
//             if (e.currentTarget.innerText !== text) {
//                 e.currentTarget.innerText = text;

//                 // keep cursor at end
//                 const range = document.createRange();
//                 range.selectNodeContents(e.currentTarget);
//                 range.collapse(false);
//                 const sel = window.getSelection();
//                 sel.removeAllRanges();
//                 sel.addRange(range);
//             }

//             onEdit?.(text);
//         }}
//     >
//         {children}
//     </div>
// );
// ✅ FIXED: Uses ref so edits are NEVER reset by React re-renders
const EditableBlock = React.memo(({ children, onEdit }) => {
  const divRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    // ✅ Set content only ONCE on first mount — never again
    if (divRef.current && !initializedRef.current) {
      initializedRef.current = true;
      // Content already rendered by React on first mount
    }
  }, []);

  return (
    <div
      ref={divRef}
      contentEditable={true}
      suppressContentEditableWarning={true}
      style={{
        outline: "1px dashed gray",
        padding: "4px",
        marginBottom: "10px",
      }}
      onInput={(e) => {
        let text = e.currentTarget.innerText;
        text = text.replace(
          /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
          "",
        );
        if (e.currentTarget.innerText !== text) {
          e.currentTarget.innerText = text;
          const range = document.createRange();
          range.selectNodeContents(e.currentTarget);
          range.collapse(false);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
        onEdit?.(text);
      }}
    >
      {/* ✅ Only rendered on first mount — React won't touch this after init */}
      {!initializedRef.current && children}
    </div>
  );
});
const removeEmojis = (text) => {
  return text.replace(
    /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu,
    "",
  );
};

const GRDraftList = () => {
  // const { id } = useParams();
  // console.log("Grid i get :: ", id);
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const {
    getGRNPendingList,
    ProposalApprovalOperation,
    EditDraftCopy,
    Usermenu,
    GetMyDepartmentAccess,
  } = context;

  const [technicalInwards, setTechnicalInwards] = useState([]);

  const [DraftList, setDraftList] = useState();
  const [grData, setgrData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [goingYear, setYear] = useState([]);
  const [showmenu, setShowmenu] = useState(1);
  const [removedProposals, setRemovedProposals] = useState([]);
  const [userDetail, setUserDetail] = useState({});
  const grContentRef = useRef(null); // ✅ ADD THIS — points to live editable content
  const [grInitialized, setGrInitialized] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
const [selectedZillaParishad, setSelectedZillaParishad] = useState("");
  const [exportingPDF, setExportingPDF] = useState(false);

  /////Adddddd
    const parseIds = (v) => {
    try {
      const p = typeof v === "string" ? JSON.parse(v) : v;
      return (Array.isArray(p) ? p : [p]).map(Number).filter(Boolean);
    } catch {
      return [];
    }
  };
    const [myDepartments, setMyDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    useEffect(() => {
      (async () => {
        try {
          const r = await GetMyDepartmentAccess();
          setMyDepartments(r?.data?.departments || []);
        } catch (e) {
          console.error("GetMyDepartmentAccess failed", e);
        }
      })();
    }, []);


  console.log("grData: ", grData);

  const fetchuserDetail = async () => {
    try {
      let res = await Usermenu();
      console.log("Data i get user menty ====> ", res.Data);
      setUserDetail(res.Data);
    } catch (err) {
      alert("Internal Server Error");
    }
  };

  useEffect(() => {
    fetchuserDetail();
  }, []);
  console.log("fsdfADfdfdfs", userDetail);

  // const [DraftContent, setDraftContent] = useState();
  const [selectedGRID, setSelectedGRID] = useState();
  const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const [isEdited, setIsEdited] = useState(false);

  console.log("selectedHeadCode: ", selectedHeadCode);
  console.log("DraftList: ", DraftList);

  const uniqueBills = filteredBills.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.GRID === item.GRID),
  );

  const totalPages = Math.max(1, Math.ceil(uniqueBills.length / billsPerPage));
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const sortedBills = Array.isArray(uniqueBills)
    ? uniqueBills
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];

    const currentBills = exportingPDF ? sortedBills : sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);

  const nav = useNavigate();
  const getTechnicalInwardsList = async () => {
    // let data = await getGRNPendingList("null", "getgrdraftList");
    let data = await getGRNPendingList("null", "getgrdraftList");
    const sortedData = data.sort((a, b) => new Date(a.Date) - new Date(b.Date));
    console.log("data------------", sortedData);
    setTechnicalInwards(sortedData);
    setFilteredBills(sortedData);
  };

  useEffect(() => {
    getTechnicalInwardsList();
  }, []);

  useEffect(() => {
        let filtered = [...technicalInwards];

        console.log("=================================");
        console.log("Selected Financial Year:", selectedFinancialYear);
        console.log("Selected Zilla Parishad:", selectedZillaParishad);
        console.log("Search Term:", searchTerm);
        console.log("Total Records:", technicalInwards.length);
        console.log("First Record ProposalYear:", technicalInwards[0]?.ProposalYear);
        console.log("=================================");

        // 🔹 Financial Year Filter
        if (selectedFinancialYear) {
            filtered = filtered.filter((item) => {
                const proposalYear = String(item.ProposalYear || "").trim();

                // Convert 2025-26 -> 2025-2026
                const selectedYear = selectedFinancialYear.replace(
                    /^(\d{4})-(\d{2})$/,
                    (_, start, end) => `${start}-20${end}`
                );

                return proposalYear === selectedYear;
            });

            console.log("After Financial Year Filter:", filtered.length);
        }

        // 🔹 Zilla Parishad Filter
        if (selectedZillaParishad) {
            filtered = filtered.filter(
                (item) =>
                    String(item.ZillaParishad || "").trim() ===
                    String(selectedZillaParishad || "").trim()
            );

            console.log(
                "After Zilla Parishad Filter:",
                filtered.length
            );
        }


     //////// 🔹 Department Filter
    if (selectedDepartment) {
      filtered = filtered.filter((item) =>
        parseIds(item.DepartmentAccessID).includes(Number(selectedDepartment)),
      );
    }



        // 🔹 Search Filter
        if (searchTerm.trim()) {
            const lowerSearchTerm = searchTerm.toLowerCase();

            filtered = filtered.filter((bill) =>
                Object.values(bill).some((val) =>
                    String(val || "")
                        .toLowerCase()
                        .includes(lowerSearchTerm)
                )
            );

            console.log(
                "After Search Filter:",
                filtered.length
            );
        }

        console.log("Final Filtered Records:", filtered.length);

        setFilteredBills(filtered);
        setCurrentPage(1);

    }, [
        technicalInwards,
        searchTerm,
        selectedFinancialYear,
        selectedZillaParishad,
        selectedDepartment,     // नवीन
    ]);

  // useEffect(() => {
  //   const lowerSearchTerm = searchTerm.toLowerCase();
  //   let filtered = technicalInwards.filter((bill) =>
  //     Object.values(bill).some((val) =>
  //       (val || "").toString().toLowerCase().includes(lowerSearchTerm),
  //     ),
  //   );
  //    if (selectedDistrict) {
  //       filtered = filtered.filter(
  //           (bill) => bill.ZillaParishad === selectedDistrict
  //       );
  //   }
  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [searchTerm, technicalInwards, selectedDistrict]);



  const getDraftlistbygeidwise = async (grid) => {
    try {
      let res = await getGRNPendingList(grid, "getgrdraftListidwise");
      setDraftList(res);
      setgrData(res[0]);
      setSelectedGRID(grid);
      setSelectedHeadCode(res[0].HeadCode);
    } catch (err) {
      console.log(err);
    }
  };

  const districtOptions = [
    ...new Set(
        technicalInwards
            ?.map((item) => item.ZillaParishad)
            .filter(Boolean)
    ),
].sort();

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  function getFinancialYears() {
    const today = new Date();
    let currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // Months are 0-indexed

    // If before April, financial year belongs to previous year
    if (currentMonth < 4) {
      currentYear -= 1;
    }

    const formatFY = (startYear) =>
      `${startYear}-${(startYear + 1).toString().slice(-2)}`;

    return [
      formatFY(currentYear - 2),
      formatFY(currentYear - 1),
      formatFY(currentYear),
    ];
  }

  useEffect(() => {
    let a = getFinancialYears();
    setYear(a);
  }, []);

  const zillaParishadList = [
        ...new Set(
            technicalInwards
                ?.map((item) => item.ZillaParishad)
                .filter(Boolean)
        ),
    ];

  // const downloadDivAsPDF = async (divId) => {
  //     setLoading(true);
  //     const input = document.getElementById(divId);
  //     if (!input) return;
  //     const element = document.getElementById(divId);
  //     if (!element) {
  //         setLoading(false);
  //         return;
  //     }
  //     const noPrintEls = Array.from(document.querySelectorAll('.no-print'));
  //     const originalDisplays = noPrintEls.map(el => el.style.display);

  //     try {
  //         // Hide elements not to be printed
  //         noPrintEls.forEach(el => (el.style.display = "none"));
  //         await new Promise(r => setTimeout(r, 100));

  //         const options = {
  //             margin: [4, 2, 4, 2], // top, left, bottom, right (mm)
  //             filename: `EditGRdraft_${selectedGRID}.pdf`,
  //             image: { type: "jpeg", quality: 0.85 },
  //             html2canvas: {
  //                 scale: 2,
  //                 useCORS: true,
  //                 scrollY: 0
  //             },
  //             jsPDF: {
  //                 unit: "mm",
  //                 format: "a4",
  //                 orientation: "portrait"
  //             },
  //             pagebreak: { mode: ["avoid-all", "legacy"] }
  //         };

  //         const worker = html2pdf().set(options).from(element);

  //         // Generate PDF
  //         const pdf = await worker.toPdf().get("pdf");

  //         // Save locally
  //         pdf.save(options.filename);

  //         // Convert to blob (for API upload)
  //         const blob = pdf.output("blob");

  //         // Upload API
  //         const formData = new FormData();
  //         formData.append("file", blob, options.filename);
  //         formData.append("GRID", selectedGRID);
  //         formData.append("RemoveProposalsID", JSON.stringify(removedProposals));
  //         formData.append("UpdatedGRAmount", grData?.GRAmount);
  //         formData.append("EditedBy", userDetail.Role);

  //         const response = await EditDraftCopy(formData);
  //         alert(response.message);

  //         if (response.status) {
  //             window.location.reload();
  //         }

  //     } catch (err) {
  //         console.error("PDF generation error:", err);
  //         alert("Failed to generate PDF. Please try again.");
  //     } finally {
  //         // Restore hidden elements
  //         noPrintEls.forEach((el, idx) => {
  //             el.style.display = originalDisplays[idx] || "";
  //         });
  //         setLoading(false);
  //     }
  // };
  const downloadDivAsPDF = async () => {
    setLoading(true);

    // ✅ Read from ref — always has the LATEST edited content
    const editableDiv = grContentRef.current;

    if (!editableDiv) {
      alert("Content not found!");
      setLoading(false);
      return;
    }

    // ✅ Hide no-print buttons inside the editable area
    const noPrintEls = Array.from(editableDiv.querySelectorAll(".no-print"));
    const originalDisplays = noPrintEls.map((el) => el.style.display);
    noPrintEls.forEach((el) => (el.style.display = "none"));

    // Wait for DOM to update after hiding
    await new Promise((r) => setTimeout(r, 150));

    try {
      const options = {
        margin: [4, 2, 4, 2],
        filename: `EditGRdraft_${selectedGRID}.pdf`,
        image: { type: "jpeg", quality: 0.85 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          scrollY: -window.scrollY,
          windowWidth: document.documentElement.scrollWidth,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
        pagebreak: { mode: ["avoid-all", "legacy"] },
      };

      // ✅ KEY FIX: Generate PDF from the live ref element (has all edits)
      const worker = html2pdf().set(options).from(editableDiv);
      const pdf = await worker.toPdf().get("pdf");

      // ✅ Save to user's device
      pdf.save(options.filename);

      // ✅ Upload blob to backend
      const blob = pdf.output("blob");

      const formData = new FormData();
      formData.append("file", blob, options.filename);
      formData.append("GRID", selectedGRID);
      formData.append("RemoveProposalsID", JSON.stringify(removedProposals));
      formData.append("UpdatedGRAmount", grData?.GRAmount);
      formData.append("EditedBy", userDetail.Role);

      const response = await EditDraftCopy(formData);
      alert(response.message);

      if (response.status) {
        window.location.reload();
      }
    } catch (err) {
      console.error("PDF generation error:", err);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      // ✅ Restore hidden elements
      noPrintEls.forEach((el, idx) => {
        el.style.display = originalDisplays[idx] || "";
      });
      setLoading(false);
    }
  };

  // ✅ Inject GR HTML into contentEditable ONCE — never re-renders after this
  useEffect(() => {
    if (
      showmenu === 2 &&
      grContentRef.current &&
      grData &&
      DraftList &&
      !grInitialized
    ) {
      const htmlString = ReactDOMServer.renderToStaticMarkup(renderGR());
      grContentRef.current.innerHTML = htmlString;
      setGrInitialized(true);
    }
  }, [showmenu, grData, DraftList, grInitialized]);

  useEffect(() => {
      const container = grContentRef.current;
      if (!container) return;
  
      const handleContainerClick = (e) => {
          const btn = e.target.closest("button[data-proposal-id]");
          if (!btn) return;
          const proposalId = btn.getAttribute("data-proposal-id");
          handleRemoveProposal(proposalId); // ⚠️ captured once, never refreshed
      };
  
      container.addEventListener("click", handleContainerClick);
      return () => container.removeEventListener("click", handleContainerClick);
  }, [showmenu, grInitialized]); // ⚠️ only re-runs on these two changes

  // ✅ Reset when going back to list
  useEffect(() => {
    if (showmenu === 1) {
      setGrInitialized(false);
    }
  }, [showmenu]);


  const exportTableByClassToExcel = async (data, filename = "GR_Draft_List.xlsx") => {
            if (!Array.isArray(data) || data.length === 0) {
                alert("No data available");
                return;
            }
            setLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 500));
            try {
                    const showHeadCode =
            userDetail?.Role !== "RDD Section Officer" &&
            userDetail?.Role !== "RDD Checker(ASO)";
                let totalGRAmount = 0;

          const sortedData = [...data].sort((a, b) => {
            return new Date(b.GRDate) - new Date(a.GRDate);
        });

        const excelData = sortedData.map((project, index) => {
            const amount = Number(project.GRAmount || 0);
            totalGRAmount += isNaN(amount) ? 0 : amount;

                    return {
                        "Sr.No": index + 1,
                        "GR Number": project.GRNumber || "-",
                        "GRID": project.GRID || "-",
                        ...(showHeadCode
                        ? {
                            "HeadCode":
                                project.HeadCode || "-"
                        }
                        : {}),
                        "Proposal Year": project.ProposalYear || "-",
                        "Zilla Parishad": project.ZillaParishad || "-",
                        "GR Amount": Number(project.GRAmount || 0),
                        "GR Date": project.GRDate
                            ? new Date(project.GRDate).toLocaleDateString("en-IN")
                            : "-",
                        "GR Approval Copy": project.DraftName || project.GRDraftCopy || "No Copy",
                        "Edited By": project.EditedBy || "No One",
                        "Uploaded By": project.Uploadedby || "No One",
                    };
                });

                // TOTAL ROW
                excelData.push({
                    "Sr.No": "",
                    "GR Number": "",
                    "GRID": "",
                    ...(showHeadCode
                ? {
                    "HeadCode": ""
                }
                : {}),
                    "Proposal Year": "",
                    "Zilla Parishad": "TOTAL",
                    "GR Amount": totalGRAmount,
                    "GR Date": "",
                    "GR Approval Copy": "",
                    "Edited By": "",
                    "Uploaded By": "",
                });

                const worksheet = XLSX.utils.json_to_sheet(excelData);

                worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));
                worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
                worksheet["!autofilter"] = {
                    ref: XLSX.utils.encode_range({
                        s: { r: 0, c: 0 },
                        e: { r: excelData.length - 2, c: Object.keys(excelData[0]).length - 1 },
                    }),
                };

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "GR Draft List");
                XLSX.writeFile(workbook, filename);
            } catch (error) {
                console.error("Excel Export Error:", error);
                alert("Failed to generate Excel file.");
            } finally {
                setLoading(false);
            }
        };

const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500;
    setExportingPDF(true);
    setLoading(true);
    await new Promise((res) => setTimeout(res, 600));

    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
        setExportingPDF(false);
        setLoading(false);
        return;
    }

    const isPageTotalRow = (row) => /page\s*total/i.test(row.textContent);
    const isGrossTotalRow = (row) => /gross\s*total/i.test(row.textContent);

    try {
        // Data rows only (exclude Page Total and Gross Total rows)
        const dataRows = Array.from(originalTable.querySelectorAll("tbody tr")).filter(
            (r) => !isPageTotalRow(r) && !isGrossTotalRow(r)
        );
        const totalRows = dataRows.length;

        for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
            const end = Math.min(start + CHUNK_SIZE, totalRows);
            const isLastChunk = end >= totalRows;

            const table = originalTable.cloneNode(true);

            // 1) Remove Page Total, rename Gross Total -> Total (keeps same style/colors)
            table.querySelectorAll("tr").forEach((row) => {
                if (isPageTotalRow(row)) {
                    row.remove();
                } else if (isGrossTotalRow(row)) {
                    if (!isLastChunk) {
                        row.remove(); // show Total only on last chunk
                    } else {
                        row.querySelectorAll("th, td").forEach((cell) => {
                            if (/gross\s*total/i.test(cell.textContent)) {
                                cell.textContent = cell.textContent.replace(/gross\s*total/i, "Total");
                            }
                        });
                    }
                }
            });

            // 2) Keep only this chunk's data rows and renumber Sr No from 1
            const rows = Array.from(table.querySelectorAll("tbody tr")).filter(
                (r) => !isGrossTotalRow(r) && !/^\s*total\s*$/i.test(r.cells[0]?.textContent || "")
                    && !/^\s*total\b/i.test(r.textContent)
            );

            rows.forEach((row, index) => {
                if (index < start || index >= end) {
                    row.remove();
                } else if (row.cells[0]) {
                    row.cells[0].textContent = String(index + 1);
                }
            });

            document.body.appendChild(table);
            const pdf = new jsPDF("p", "mm", "a4");
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const topMargin = 25;
            const sideMargin = 10;
            const bottomMargin = 15;

            pdf.setFontSize(16);
            pdf.setFont("helvetica", "bold");
            pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
                align: "center",
            });

            const canvas = await html2canvas(table, {
                scale: 1,
                useCORS: true,
                backgroundColor: "#2C78DB",
            });

            const imgWidth = pageWidth - sideMargin * 2;
            const pxToMm = imgWidth / canvas.width;
            const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
            const usablePageHeightPx = usablePageHeightMm / pxToMm;

            let renderedHeight = 0;
            let pageNumber = 0;

            while (renderedHeight < canvas.height) {
                const sliceHeight = Math.min(
                    usablePageHeightPx,
                    canvas.height - renderedHeight
                );

                const pageCanvas = document.createElement("canvas");
                const context = pageCanvas.getContext("2d");

                pageCanvas.width = canvas.width;
                pageCanvas.height = sliceHeight;

                context.drawImage(
                    canvas, 0, renderedHeight, canvas.width, sliceHeight,
                    0, 0, canvas.width, sliceHeight
                );

                const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);
                if (pageNumber > 0) pdf.addPage();

                pdf.addImage(imgData, "JPEG", sideMargin, topMargin, imgWidth, sliceHeight * pxToMm);

                renderedHeight += sliceHeight;
                pageNumber++;
            }

            pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
            document.body.removeChild(table);
            await new Promise((resolve) => setTimeout(resolve, 300));
        }
    } catch (error) {
        console.error("PDF Export Error:", error);
        alert("Failed to generate PDF.");
    } finally {
        setExportingPDF(false);
        setLoading(false);
    }
};

  // const handleRemoveProposal = (proposalId) => {
  //     if (!window.confirm("Are you sure you want to remove this proposal?")) return;
  //     setDraftList((prevList) => {
  //         const updatedList = prevList.filter((item) => item.ProposalID !== proposalId);

  //         console.log("Old GR Amount == ", grData.GRAmount);

  //         const newTotal = updatedList.reduce(
  //             (sum, item) => sum + (parseFloat(item.Proposal_amount) || 0),
  //             0
  //         );

  //         console.log("New Value Gr Amount ===", newTotal);
  //         setgrData((prev) => ({
  //             ...prev,
  //             GRAmount: `${newTotal}`
  //         }));

  //         return updatedList;
  //     });

  //     setRemovedProposals((prevRemoved) => [...prevRemoved, proposalId]);
  // };
  // const handleRemoveProposal = (proposalId) => {
  //   if (!window.confirm("Are you sure you want to remove this proposal?"))
  //     return;

  //   //  Remove row directly from live DOM — no React re-render
  //   if (grContentRef.current) {
  //     const allButtons = grContentRef.current.querySelectorAll("button");
  //     allButtons.forEach((btn) => {
  //       if (btn.getAttribute("data-proposal-id") === String(proposalId)) {
  //         const row = btn.closest("tr");
  //         if (row) row.remove();
  //       }
  //     });

  //     // Recalculate total from remaining rows
  //     const amountCells = grContentRef.current.querySelectorAll(
  //       ".proposal-amount-cell",
  //     );
  //     let newTotal = 0;
  //     amountCells.forEach((cell) => {
  //       newTotal += parseFloat(cell.innerText || 0);
  //     });

  //     //  Update total display cells in DOM
  //     const totalCells =
  //       grContentRef.current.querySelectorAll(".gr-total-cell");
  //     totalCells.forEach((cell) => {
  //       cell.innerText = newTotal;
  //     });
  //   }

  //   //  Update state only for API — does NOT affect contentEditable DOM
  //   setRemovedProposals((prev) => [...prev, proposalId]);
  //   setgrData((prev) => {
  //     const newTotal = (DraftList || [])
  //       .filter((item) => item.ProposalID !== proposalId)
  //       .reduce(
  //         (sum, item) => sum + (parseFloat(item.Proposal_amount) || 0),
  //         0,
  //       );
  //     return { ...prev, GRAmount: `${newTotal}` };
  //   });
  //   setDraftList((prev) =>
  //     prev.filter((item) => item.ProposalID !== proposalId),
  //   );
  // };
  // console.log("Removed Proposal ID :: ", removedProposals);

  const handleRemoveProposal = (proposalId) => {
      console.log("====================================");
      console.log("🗑️ REMOVE BUTTON CLICKED");
      console.log("Proposal ID:", proposalId);
      console.log("====================================");
    if (!DraftList || DraftList.length <= 1) {
        console.log("❌ Cannot remove the last remaining proposal");

        alert("At least one proposal must remain.");
        return;
    }
      if (!window.confirm("Are you sure you want to remove this proposal?")) {
          console.log("❌ Remove cancelled");
          return;
      }
  
      const selectedId = String(proposalId).trim();
  
      // --------------------------------------------------
      // 1. FIND PROPOSAL
      // --------------------------------------------------
      const proposalToRemove = (DraftList || []).find(
          (item) =>
              String(item.ProposalID).trim() === selectedId
      );
  
      if (!proposalToRemove) {
          console.log("❌ Proposal not found:", selectedId);
          return;
      }
  
      // --------------------------------------------------
      // 2. REMOVE FROM LIVE DOM
      // --------------------------------------------------
      if (grContentRef.current) {
  
          const buttons =
              grContentRef.current.querySelectorAll(
                  "button[data-proposal-id]"
              );
  
          let removedRow = null;
  
          buttons.forEach((button) => {
  
              const id =
                  String(
                      button.getAttribute("data-proposal-id")
                  ).trim();
  
              if (id === selectedId) {
                  removedRow = button.closest("tr");
              }
          });
  
          if (removedRow) {
              removedRow.remove();
  
              console.log("✅ Row removed from DOM");
          }
  
          // --------------------------------------------------
          // 3. UPDATE SERIAL NUMBERS
          // --------------------------------------------------
          const tables =
              grContentRef.current.querySelectorAll(
                  "table.pdf-table"
              );
  
          tables.forEach((table) => {
  
              const rows =
                  table.querySelectorAll("tbody tr");
  
              let serialNumber = 1;
  
              rows.forEach((row) => {
  
                  // Skip total row
                  if (
                      row.querySelector(".gr-total-cell")
                  ) {
                      return;
                  }
  
                  const button =
                      row.querySelector(
                          "button[data-proposal-id]"
                      );
  
                  // Only rows having Remove button
                  if (button) {
  
                      const firstCell = row.querySelector("td");
  
                      if (firstCell) {
                          firstCell.textContent =
                              serialNumber++;
  
                          console.log(
                              "Updated serial:",
                              firstCell.textContent
                          );
                      }
                  }
              });
          });
  
          // --------------------------------------------------
          // 4. RECALCULATE TOTAL AMOUNT FROM DOM
          // --------------------------------------------------
          const amountCells =
              grContentRef.current.querySelectorAll(
                  ".proposal-amount-cell"
              );
  
          let newTotal = 0;
  
          amountCells.forEach((cell) => {
  
              const amount =
                  parseFloat(
                      String(cell.textContent)
                          .replace(/,/g, "")
                          .trim()
                  ) || 0;
  
              newTotal += amount;
          });
  
          console.log("💰 New total:", newTotal);
  
          // --------------------------------------------------
          // 5. UPDATE ALL TOTAL CELLS
          // --------------------------------------------------
          const totalCells =
              grContentRef.current.querySelectorAll(
                  ".gr-total-cell"
              );
  
          totalCells.forEach((cell) => {
  
              const strong =
                  cell.querySelector("strong");
  
              if (strong) {
                  strong.textContent = newTotal;
              } else {
                  cell.textContent = newTotal;
              }
          });
      }
  
      // --------------------------------------------------
      // 6. UPDATE REMOVED PROPOSALS
      // --------------------------------------------------
      setRemovedProposals((prev) => {
  
          const alreadyExists = prev.some(
              (item) =>
                  String(item).trim() === selectedId
          );
  
          if (alreadyExists) {
              return prev;
          }
  
          const updated = [
              ...prev,
              proposalId
          ];
  
          console.log(
              "🗑️ Removed Proposal IDs:",
              updated
          );
  
          return updated;
      });
  
      // --------------------------------------------------
      // 7. UPDATE DRAFT LIST STATE
      // --------------------------------------------------
      setDraftList((prev) => {
  
          const updatedList =
              (prev || []).filter(
                  (item) =>
                      String(item.ProposalID).trim() !==
                      selectedId
              );
  
          console.log(
              "📋 Updated DraftList:",
              updatedList
          );
  
          // --------------------------------------------------
          // 8. UPDATE GR AMOUNT IN STATE
          // --------------------------------------------------
          const newTotal =
              updatedList.reduce(
                  (sum, item) =>
                      sum +
                      (parseFloat(item.Proposal_amount) || 0),
                  0
              );
  
          setgrData((prevGR) => ({
              ...prevGR,
              GRAmount: String(newTotal)
          }));
  
          console.log(
              "💰 Updated GRAmount:",
              newTotal
          );
  
          return updatedList;
      });
  };
      console.log("Removed Proposal ID :: ", removedProposals);
      useEffect(() => {
      console.log("✅ REMOVED PROPOSALS UPDATED:", removedProposals);
  }, [removedProposals]);

  

  const GR2515Template = ({ grData, DraftList }) => {
    const { ProposalYear, ZillaParishad, GRAmount, GRNumber, GRDate } =
      grData || {};

    return (
      <div className="m-3">
        {/* HEADER */}
        <div className="d-flex justify-content-between">
          <div>जि.प. {ZillaParishad}</div>

          <div style={{ width: "55%", textAlign: "right" }}>
            सन {ProposalYear} या आर्थिक वर्षातील तरतुदीतून मा. लोकप्रतिनिधींनी
            सुचविलेल्या ग्रामीण भागातील गावांतर्गत मूलभूत सुविधा पुरविणे
            (लेखाशिर्ष २५१५ १२३८) या योजनेंतर्गत विकास कामांना मंजूरी
            देण्याबाबत.
          </div>
        </div>

        <br />
        <br />

        {/* CENTER */}
        <div className="text-center">
          <b>महाराष्ट्र शासन</b>
          <br />
          ग्रामविकास व पंचायत राज विभाग
          <br />
          <br />
          <b>शासन निर्णय क्र. {GRNumber}</b>
          <br />
          बांधकाम भवन, २५ मर्झबान रोड, फोर्ट, मुंबई-४०० ००१.
          <br />
          <b>दिनांक : {GRDate?.split("T")[0].split("-").reverse().join("/")}</b>
        </div>

        <br />
        <br />

        <p>
          <b>संदर्भ:</b>
        </p>

        <p style={{ marginLeft: "30px" }}>
          १) शासन निर्णय, ग्रा.वि.व.ज.सं.वि.क्र.झेडपीए-२०१५/प्र.क्र-१०/वित्त-९,
          दि. २५/०३/२०१५.
          <br />
          २) शासन निर्णय, ग्रा.वि.व.ज.सं.वि.क्र.विकास -
          २०१५/प्र.क्र.५२/यो-६,दि.२७/०३/२०१५.
          <br />
          ३) शासन निर्णय, ग्रा.वि.व.ज.सं.वि.क्र.विकास -
          २०१५/प्र.क्र.२७४/यो-६,दि.१६/१२/२०१५
          <br />
          ४) ग्रामविकास विभाग, शासन निर्णय क्र.विकास-२०१८/प्र.क्र.२२५/ योजना-६,
          दि.२२/१०/२०१८.
          <br />
          ५) ग्रामविकास विभाग, शासन निर्णय क्र. विकास-२०१८/प्र.क्र.२२५/योजना-६,
          दि.०१/०२/२०१९.
          <br />
          ६) ग्रामविकास विभाग, शासन शुद्धीपत्रक क्र.विकास-२०१८/प्र.क्र.२२५/
          योजना-६, दि.०८/०३/२०१९.
          <br />
          ७) ग्रामविकास विभाग, शासन निर्णय क्र.विकास-२०१९/प्र.क्र.४४/ योजना-६,
          दि.२५/०७/२०१९.
          <br />
          ८) ग्रामविकास विभाग, शासन निर्णय क्रमांक.
          विकास-२०२०/प्र.क्र.२२५/योजना-६, दि.१७/०२/२०२०.
          <br />
          ९) नियोजन विभाग, शासन निर्णय क्र.युपासु-२०२५/प्र.क्र.०७/का.१४१२, दि.०९
          जून, २०२५
          <br />
        </p>

        <br />

        <p>
          <b>शासन निर्णय :-</b>
        </p>

        <p class="indent">
          राज्यातील गावांतर्गत मुलभूत सुविधांच्या कामांसाठी निधी उपलब्ध करुन
          देण्याबाबतची मागणी अनेक लोकप्रतिनिधींकडून शासनाकडे प्राप्त होते. त्या
          अनुषंगाने लोकप्रतिनिधींनी सुचविलेल्या ग्रामीण भागातील गावांतर्गत
          मुलभूत सुविधांची कामे मंजूर करण्यासंदर्भातील मार्गदर्शक तत्वे
          संदर्भाधिन क्र. २ ते ८ येथील शासन निर्णयात स्पष्ट करण्यात आली आहेत.
        </p>

        <p class="indent">
          २. “मा. लोकप्रतिनिधींनी सुचविलेल्या ग्रामीण भागातील गावांतर्गत मुलभूत
          सुविधा पुरविणे" या योजनेंतर्गत सन {ProposalYear} या वित्तीय वर्षात{" "}
          {ZillaParishad} जिल्ह्यातील विकासकामांसाठी सोबत जोडलेल्या
          अनुसूचीप्रमाणे एकूण रु.{GRAmount} लक्ष इतक्या रक्कमेच्या कामांना
          प्रशासकीय मान्यता देण्यात येत आहे.
        </p>

        <p class="indent">
          ३. तसेच ज्या कामासाठी अनुदान मंजुर झाले आहे, त्याच कामावर खर्च करणे
          बंधनकारक राहील. सदर मंजूर कामांच्या यादीमधून संदर्भाधीन शासन निर्णय
          क्र.२ ते ८ अन्वये विहीत केलेल्या कामांनाच मंजूरी देण्यात यावी.तसेच,
          मंजूर केलेल्या कामांपैकी योजनाबाह्य कामे व जी कामे जागेअभावी किंवा इतर
          योजनेंतर्गत या आधी मंजूर असतील किंवा जी कामे ग्रामपंचायत/ग्रामीण भागात
          येत नसल्यास किंवा इतर काही कारणांमुळे सुरु करणे शक्य नसतील, अशा
          कामांची शहानिशा करुन त्या कामांची यादी/अहवाल एक महिन्याच्या आत शासनास
          सादर करावा.
        </p>

        <p class="indent">
          ४. तसेच, प्रत्येक पायाभूत सुविधेच्या कामास तांत्रिक मान्यता
          देण्यापूर्वी संदर्भाधिन शासन निर्णय क्र.९ नुसार ऑनलाईन युनिक आयडी
          क्रमांक घ्यावा व सदर आयडी क्रमांक पोर्टलवर अपलोड करावा. संदर्भाधीन
          शासन निर्णयानुसार पायाभुत सुविधेबाबत नमूद सर्व बाबींचे तंतोतंत पालन
          होईल असे पहावे.
        </p>

        <p class="indent">
          ५. सन {ProposalYear} मधील तरतूदीतून या शासन निर्णयान्वये मंजूर
          केलेल्या कामांची मुदत दि. ३१ मार्च २०२७ पर्यंत राहील. त्यामुळे सदर
          कामे मुदतीत पूर्ण करावीत. अन्यथा अशा कामांना निधी उपलब्ध करून दिला
          जाणार नाही.
        </p>

        <p class="indent">
          ६. या शासन निर्णयान्वये मंजूर केलेल्या सर्व कामांसाठी जिल्हा
          परिषदेच्या प्रचलित कार्यपध्दतीनुसार अंदाज पत्रके तयार करणे,तांत्रिक
          मंजूरी, निविदा काढणे स्वीकारणे, कार्यारंभ आदेश देणे इत्यादी बाबतची
          कार्यवाही सक्षम प्राधिकाऱ्याकडून करुन घेण्याची जबाबदारी संबंधित मुख्य
          कार्यकारी अधिकारी, जिल्हा परिषद यांची राहील. तसेच सदरील कामे मंजूर
          अनुदानाच्या मर्यादेतच पूर्ण होतील याची दक्षता घेण्यात यावी. मंजूर
          अनुदानापेक्षा जास्त खर्चाच्या कामांना मान्यता दिल्यास, त्यासाठी
          कुठल्याही स्वरुपात अतिरिक्त अनुदान उपलब्ध करुन दिले जाणार नाही. तसेच
          विहित कालावधीतच संबंधित कामे पूर्णत्वास (मार्च, २०२७ पर्यंत) आणावीत.
          मंजूर कामांना कार्यारंभ आदेश हा शासन निर्णयाच्या मुदतीच्या
          कालमर्यादेतच द्यावा. या कालावधीनंतर कार्यारंभ आदेश दिल्याचे निदर्शनास
          आल्यास संबंधितांवर शिस्तभंगाची कारवाई करण्यात येईल, याचीही नोंद
          घ्यावी.
        </p>

        <p class="indent">
          ७. सदरील कामे हाती घेण्यापूर्वी संबंधित क्षेत्रात जिल्हा परिषद, पंचायत
          समिती व ग्रामपंचायतीच्या सार्वत्रिक निवडणूका / पोट निवडणूकांसाठी
          आचारसंहिता अंमलात नाही याबाबत संबंधित मुख्य कार्यकारी अधिकारी, जिल्हा
          परिषद यांनी खात्री करावी. तसेच कामे दर्जेदार व चांगल्या प्रतीचे
          असल्याबाबत विहित समिती/ संबंधितांकडून खात्री करून घेण्यात यावी.
          कोणत्याही प्रकारची अनियमितता होणार नाही, याची सर्व संबंधितांनी दक्षता
          घ्यावी. याबाबत संबंधित मुख्य कार्यकारी अधिकारी, जिल्हा परिषद यांनी
          विशेष दक्षता घ्यावी, अन्यथा कसूरदारांवर शासनस्तरावरून कारवाई करण्यात
          येईल.
        </p>

        <p class="indent">
          ८. सदर शासन निर्णय सोबतच्या यादीतील मंजूर केलेली कामे मागील ५ वर्षात (
          २५१५ १२३८ ) लेखाशीर्षाखाली किंवा अन्य योजनेतून करून घेण्यात आली नाहीत,
          याची संबंधित यंत्रणेने खात्री करावी. जर कोणत्याही योजनेतून ५
          वर्षापूर्वी अशी कामे करून घेतली असल्यास, अशा प्रसंगी ते काम सुस्थितीत
          आहे किंवा कसे याबाबत संबंधित यंत्रणेने खात्री करूनच ती हाती घेण्यात
          यावी. तसचे अशी कामे अन्य योजनेतून मंजूर असून ती सुस्थितीत आढळल्यास अशा
          कामांच्या बाबतीत तपशीलासह शासनास अवगत करून पुढील योग्य ती कार्यवाही
          करण्यात यावी.
        </p>

        <p class="indent">
          ९. राज्यातील जिल्हा परिषदांना निधी वितरणासाठी LPRS (Liability Payment
          Register System) प्रणाली राबविण्याबाबत दि. ३१.१२.२०२० च्या शासन
          निर्णयान्वये निर्णय घेतलेला आहे. सदर निर्णयाच्या अनुषंगाने सदर मंजूर
          कामांचा निधी LPRS प्रणालीद्वारे वितरीत करण्यात येईल.
        </p>

        <p class="indent">
          १०. या मंजूर कामांसाठी सार्वजनिक बांधकाम विभागाने शासन निर्णय क्र.
          संकीर्ण२०१८/प्र.क्र.१५१/इमारती-२, दि.१४.०१.२०१९ रोजीच्या शासन
          निर्णयान्वये निश्चित केल्यानुसार दोषनिवारण दायित्व कालावधी राहील व
          त्या कालावधीचा निविदेमध्ये समावेश करण्यात यावा.
        </p>

        <p class="indent">
          ११. वरील बाबींवर होणारा खर्च मागणी क्र. एल-३ मुख्य लेखाशिर्ष २५१५-इतर
          ग्राम विकास कार्यक्रम-८००-इतर खर्च (०१) (०८) ग्रामीण भागातील विकास
          कामासाठी जिल्हा परिषदांना सहायक अनुदान (योजनांतर्गत) दत्तमत
          (२५१५-१२३८), २७ लहान बांधकामे (वेतनेतर) या लेखाशिर्षाखाली सन २०२५-२६
          या चालू वित्तीय वर्षातील तरतूदीतून भागविण्यात यावा व त्याच
          लेखाशिर्षाखाली खर्ची टाकण्यात यावा.
        </p>

        <p class="indent">
          १२. सदर शासन निर्णय, वित्त विभाग शासन परिपत्रक क्रमांक क्र.अर्थसं
          २०२५/प्र.क्र.४४/अर्थ-३, दि.०७/०४/२०२५ तसेच, नियोजन विभागाच्या
          अनौपचारिक क्र.१५९/२०२५, दि.०९.०५.२०२५ व वित्त विभागाच्या अनौपचारिक
          क्र.३५८/व्यय-१५, दि.१९.०५.२०२५ अन्वये निर्गमित करण्यात येत आहे.
        </p>

        <br />

        <p>महाराष्ट्राचे राज्यपाल यांच्या आदेशानुसार व नावाने,</p>

        <br />
        <br />

        <div style={{ textAlign: "right" }}>
          (अभिजीत तेलवेकर)
          <br />
          कार्यासन अधिकारी, महाराष्ट्र शासन
        </div>

        <br />
        <br />

        <p>
          <b>प्रति,</b>
        </p>

        <p class="indent">
          १) मा.मुख्यमंत्री, महाराष्ट्र राज्य, मंत्रालय, मुंबई -३२.
          <br />
          २) मा.उपमुख्यमंत्री तथा वित्त मंत्री, महाराष्ट्र राज्य, मंत्रालय,
          मुंबई.
          <br />
          ३) मा. उपमुख्यमंत्री तथा नगरविकास मंत्री, महाराष्ट्र राज्य, मंत्रालय,
          मुंबई.
          <br />
          ४) मा.मंत्री, ग्रामविकास यांचे खाजगी सचिव, मंत्रालय, मुंबई-३२.
          <br />
          ५) मा.राज्यमंत्री, ग्रामविकास यांचे खाजगी सचिव, मंत्रालय, मुंबई-३२.
          <br />
          ६) महालेखापाल, लेखा व अनुज्ञेयता,१/२, महाराष्ट्र, मुंबई.
          <br />
          ७) महालेखापाल, लेखा व परिक्षा, १/२, महाराष्ट्र, मुंबई.
          <br />
          ८) मुख्य कार्यकारी अधिकारी, जिल्हा परिषद, {ZillaParishad}.<br />
          ९) अतिरिक्त मुख्य कार्यकारी अधिकारी, जिल्हा परिषद, {ZillaParishad}.
          <br />
          १०) कार्यकारी अभियंता,जिल्हा परिषद, {ZillaParishad}.<br />
          ११) मुख्य लेखा व वित्त अधिकारी, जिल्हा परिषद, {ZillaParishad}.<br />
          १२) जिल्हा कोषागार अधिकारी, {ZillaParishad}.<br />
          १३) स्वीय सहायक, अतिरिक्त मुख्य सचिव, नियोजन विभाग, मंत्रालय,
          मुंबई-३२.
          <br />
          १४) स्वीय सहायक, अतिरिक्त मुख्य सचिव, वित्त विभाग, मंत्रालय, मुंबई-३२.
          <br />
          १५) स्वीय सहायक, प्रधान सचिव, ग्रामविकास विभाग, बांधकाम भवन, मुंबई-०१.
          <br />
          १६) निवडनस्ती, कार्यासन योजना-६.
        </p>

        <br />
        <br />

        {/* ================= TABLE ================= */}
        <div style={{ pageBreakBefore: "always" }} />

        <p className="text-center">
          <b>परिशिष्ट</b>
          <br />
          (शासन निर्णय क्र. {GRNumber}, दिनांक{" "}
          {GRDate?.split("T")[0].split("-").reverse().join("/")})
        </p>

        <br />

        {/* ✅ YOUR TABLE (UNCHANGED) */}
        <table contentEditable={false} className="m-auto my-4 pdf-table">
          <thead>
            <tr>
              <th>अ.क्र.</th>
              <th>कामाचे नाव</th>
              <th>रक्कम (लक्ष)</th>
            </tr>
          </thead>

          {/* <tbody>
                        {
                            DraftList?.map((proposal, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{proposal.Work_name}</td>
                                    <td>{proposal.Proposal_amount}</td>
                                    <td className="no-print">
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => handleRemoveProposal(proposal.ProposalID)}
                                        >
                                            <i className="fa fa-trash"></i> Remove
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }

                        <tr>
                            <td colSpan="2"><b>एकूण</b></td>
                            <td><b>{GRAmount}</b></td>
                        </tr>
                    </tbody> */}

          <tbody>
            {DraftList?.map((proposal, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{proposal.Work_name}</td>
                {/* ✅ ADD class */}
                <td className="proposal-amount-cell">
                  {proposal.Proposal_amount}
                </td>
                <td className="no-print">
                  {/* ✅ ADD data-proposal-id */}
                  <button
                    data-proposal-id={proposal.ProposalID}
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleRemoveProposal(proposal.ProposalID)}
                  >
                    <i className="fa fa-trash"></i> Remove
                  </button>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="2">
                <b>एकूण</b>
              </td>
              {/* ✅ ADD class */}
              <td className="gr-total-cell">
                <b>{GRAmount}</b>
              </td>
            </tr>
          </tbody>
        </table>

        <br />
        <br />

        <div style={{ textAlign: "right" }}>
          (अभिजीत तेलवेकर)
          <br />
          कार्यासन अधिकारी, महाराष्ट्र शासन
        </div>
      </div>
    );
  };

  const GR3054Template = ({ grData, DraftList }) => {
    const { ProposalYear, ZillaParishad, GRAmount, GRNumber, GRDate, GRID } =
      grData || {};

    // previous year
    const getPreviousFinancialYear = (yearStr) => {
      if (!yearStr) return "";
      const [start, end] = yearStr.split("-").map(Number);
      return `${start - 1}-${end - 1}`;
    };

    const previousYear = getPreviousFinancialYear(ProposalYear);

    // dynamic groups
    const classMap = {
      A: "गट (अ)",
      B: "गट (ब)",
      C: "गट (क)",
      D: "गट (ड)",
    };

    const uniqueClasses = [...new Set(DraftList?.map((p) => p.classOfWork))]
      .filter(Boolean)
      .sort();

    const dynamicGroups = uniqueClasses.map((c) => classMap[c]).join(" व ");

    return (
      <div className="page">
        {/* HEADER */}
        <div className="d-flex justify-content-between">
          <p>जि.प. {ZillaParishad}</p>

          <p className="fw-bold text-end" style={{ width: "50%" }}>
            सन {ProposalYear} या आर्थिक वर्षासाठी लेखाशिर्ष 3054-2419 रस्ते व
            पुल दुरुस्ती परिरक्षण कार्यक्रम अंतर्गत {dynamicGroups}
            मधील कामास प्रशासकीय मंजूरी देण्याबाबत
          </p>
        </div>

        <br />

        {/* CENTER */}
        <div className="center">
          <p>
            <b>महाराष्ट्र शासन</b>
          </p>
          <p>ग्रामविकास विभाग</p>
          <p>
            <b>शासन निर्णय क्र. {GRNumber}</b>
          </p>
          <p>बांधकाम भवन, 25 मर्झबान रोड, फोर्ट, मुंबई-400 001.</p>
          <p>
            <b>
              दिनांक : {GRDate?.split("T")[0].split("-").reverse().join("/")}
            </b>
          </p>
        </div>

        <br />

        <p>
          <b>संदर्भ:</b>
        </p>
        <p className="ps-4">
          1) शासन निर्णय,ग्रा.वि. व ज.सं. विभाग, क्र.
          जिपर-2012/प्र.क्र.118/पं.रा-8, दि.10.09.2012
        </p>
        <p className="ps-4">
          2) शासन निर्णय, नियोजन विभाग क्र. युपासु-2025/प्र.क्र.07/का.1412,
          दि.09 जून, 2025
        </p>
        <p className="ps-4">
          3) जिल्हा परिषद, {ZillaParishad} यांचा दि.
          {GRDate?.split("T")[0].split("-").reverse().join("/")}
        </p>

        <br />

        <p>
          <b>शासन निर्णय :-</b>
        </p>

        <p class="indent">
          राज्यातील जिल्हा परिषदांच्या अखत्यारीतील ग्रामीण मार्ग व इतर जिल्हा
          मार्ग यांच्या देखभाल व दुरुस्तीसाठी लेखाशिर्ष 3054-2419 अंतर्गत निधी
          मंजूर करण्यात येतो.
        </p>

        <p class="indent">
          जिल्हा परिषद, {ZillaParishad} यांच्या संदर्भाधीन क्र.5 येथील
          प्रस्तावाच्या अनुषंगाने जिल्हा परिषद, {ZillaParishad} करिता{" "}
          {dynamicGroups} मधील रु.{GRAmount} लक्ष किंमतीच्या कामास सोबतच्या
          परिशिष्ट क्र. 1 व 2 अन्वये प्रशासकीय मंजूरी देण्यात येत असून ही मंजूरी
          खालील अटींचे पूर्णत: अनुपालन होण्याच्या अधीन राहून देण्यात येत आहे:-
        </p>

        <br></br>

        <p class="indent">
          1) संदर्भाधीन क्र.1 येथील शासन निर्णयामधील मार्गदर्शक सूचनांचे
          काटेकोरपणे पालन करण्यात यावे.
        </p>
        <p class="indent">
          2) कार्यक्रमास प्रदान केलेली मंजूरी ही कामनिहाय व किंमतप्रधान आहे.
          त्यामुळे अंतिम खर्च हा मंजूर किंमतीच्या मर्यादेतच राहील, याची दक्षता
          घेण्यात यावी.
        </p>
        <p class="indent">
          3) नव्या कामांच्या निविदा निश्चितीची कार्यवाही एका विभागासाठी एकाच
          निविदा सूचनेमध्ये सर्व कामांच्या निविदा बोलावून करण्यात यावी.
        </p>
        <p class="indent">
          4) तसेच, प्रत्येक पायाभूत सुविधेच्या कामास तांत्रिक मान्यता
          देण्यापूर्वी संदर्भाधिन शासन निर्णय क्र.4 नुसार ऑनलाईन युनिक आयडी
          क्रमांक घ्यावा व सदर आयडी क्रमांक पोर्टलवर अपलोड करावा. संदर्भाधीन
          शासन निर्णयानुसार पायाभुत सुविधेबाबत नमूद सर्व बाबींचे तंतोतंत पालन
          होईल असे पहावे.
        </p>
        <p class="indent">
          5) तपशीलवार कार्यक्रम मंजूरीच्या शासनाकडील प्रतीवरील जॉब क्रमांक
          जिल्हा परिषदेकडील प्रतीवर नमूद करावा.
        </p>

        <p class="indent">
          6) सदर आदेशामधील मंजूर काम याच किंवा लगतच्या आर्थिक वर्षात पूर्ण
          करावीत. अन्यथा, अशा कामांना त्यानंतर निधी उपलब्ध करुन दिला जाणार नाही.
          अशी कामे आहे त्या स्थितीत अंतिम करावीत. त्याची सर्वस्वी जबाबदारी
          जिल्हा परिषदेची राहील.
        </p>

        <p class="indent">
          7) प्रस्तावातील कामे अन्य योजनेत समाविष्ट नाहीत याची खातरजमा तांत्रिक
          मंजूरी देण्यापूर्वी कार्यकारी अभियंता यांनी करावी. काही कामे दुसऱ्या
          योजनेतून किंवा कार्यक्रमातून मंजूर आहेत असे आढळल्यास तात्काळ शासनास
          कळवून मंजूर जॉब क्रमांक रद्द करुन घेणेची कार्यवाही कार्यकारी अभियंता
          यांनी करावी.
        </p>

        <p class="indent">
          8) या मंजूर कार्यक्रमा व्यतिरिक्त कोणतेही काम हाती घेण्यात येवू नये,
          अन्यथा याची सर्वस्वी जबाबदारी अतिरिक्त मुख्य कार्यकारी अधिकारी व
          कार्यकारी अभियंता (बांध) यांची वैयक्तिक असणार आहे याची दक्षता घेण्यात
          यावी.
        </p>

        <p class="indent">
          9) या मंजूर कामांसाठी सार्वजनिक बांधकाम विभागाने दि.21.11.2011
          रोजीच्या शासन निर्णयान्वये निश्चित केल्यानुसार दोषनिवारण दायित्व
          कालावधी काम पूर्ण झाल्यापासून 2 वर्ष इतका राहील याचा निविदेमध्ये
          समावेश करण्यात यावा.
        </p>

        <p class="indent">
          10) ठेकेदाराच्या दोष निवारण कालावधीत असलेल्या कामावर सदर
          कार्यक्रमामधून खर्च करण्यात येवू नये.
        </p>

        <p class="indent">
          11) या मंजूर कार्यक्रमातील कामाचा वाव जर अन्य कोणत्याही योजनेतील /
          योजनेतर स्थानिक क्षेत्राकडे वा राज्य क्षेत्राकडे मंजूर कामात समाविष्ट
          असेल तर तेवढा वाव या मंजूर कार्यक्रमातील कामातून वगळावा.
        </p>

        <p class="indent">
          12) स्थानिक आचारसंहितेचा भंग होणार नाही याबाबत जिल्हा परिषदेने दक्षता
          घ्यावी.
        </p>

        <p class="indent">
          13) कामे सुरु करण्यापूर्वी, कामे प्रगतीत असताना व कामे पूर्ण
          झाल्यानंतर छायाचित्र (फोटोग्रॉफस्) घेण्यात यावीत व विभागीय
          कार्यालयाच्या अभिलेख्यांसोबत ठेवावेत.
        </p>

        <p class="indent">
          14) संरक्षक भिंतीच्या बांधकामातील तरतूदी हया हिल रोड मॅन्युॲल (Hill
          Road Manual) प्रमाणे तपासून पहाव्या व त्यानुसार भिंतीचे संकल्पन करावे.
        </p>

        <p class="indent">
          15) सदर आदेशातील कामे यापूर्वी मंजूर असलेल्या सन {previousYear} व सन{" "}
          {ProposalYear} या आर्थिक वर्षातील नसल्याची खातरजमा कार्यकारी अभियंता
          (बांधकाम), जिल्हा परिषद यांनी करावी. तसेच काही कामे यापूर्वी मंजूर
          असल्याचे आढळल्यास सदर कामे शासनाकडून तातडीने बदलून घेण्याची जबाबदारी
          कार्यकारी अभियंता (बांधकाम), जिल्हा परिषद यांची राहील.
        </p>

        <p class="indent">
          16) कामाचे नावातील अंशत: बदल किंवा मंजूर कामाऐवजी नवीन काम/कामे मंजूर
          करण्याबाबत प्रस्ताव सादर करण्यापुर्वी जिल्हा परिषदेने मंजूर कामांचा
          विस्तृत आढावा घेऊन स्वत:ची खात्री करावी. त्यानंतर कामाचे नावातील अंशत:
          बदल किंवा मंजूर कामाऐवजी नवीन काम/कामे मंजूर करण्याबाबतचा प्रस्ताव
          एकाच वेळी सविस्तर कारणांसह अतिरिक्त मुख्य कार्यकारी अधिकारी यांचे
          स्वाक्षरीने या विभागास तथा शासनास, कार्यक्रम मंजूर झाल्याच्या
          दिनांकापासून 45 दिवसाच्या आत सादर करावा.
        </p>

        <br />

        <p class="indent">
          2. सदरील खर्च हा मागणी क्रमांक एल-3, 3054, मार्ग व पूल, 196, जिल्हा
          परिषदा व जिल्हास्तरीय पंचायतींना सहाय्य, (00) (01) महाराष्ट्र जिल्हा
          परिषद व पंचायत समिती अधिनियम, 1961 च्या कलम 182 अन्वये दळणवळणाच्या
          मार्गाच्या दुरुस्तीसाठी जिल्हा परिषदांना संप्रयोजन अनुदान, 27, लहान
          बांधकामे, लेखाशिर्ष 3054-2419 या लेखाशिर्षाखाली सन {ProposalYear} च्या
          अर्थसंकल्पिय तरतूदीतून भागविण्यात यावा. महाराष्ट्राचे राज्यपाल यांच्या
          आदेशानुसार व नावाने.
        </p>

        <br />

        <div className="text-end">
          <p className="text-center fw-bold">
            {userDetail?.RoleID == "25" || userDetail?.RoleID == "24"
              ? "सयाजी पाटील"
              : userDetail?.RoleID == "40" || userDetail?.RoleID == "41"
                ? "अभिजित तेलवेकर"
                : ""}
            <br />
            कार्यासन अधिकारी, महाराष्ट्र शासन
          </p>
        </div>

        <br />

        <p>
          <b>प्रति,</b>
        </p>

        <p class="indent">
          1) मा. मंत्री, ग्राम विकास यांचे खाजगी सचिव, मंत्रालय, मुंबई-32
        </p>
        <p class="indent">
          2) मा. राज्यमंत्री, ग्राम विकास यांचे खाजगी सचिव, मंत्रालय, मुंबई-32
        </p>
        <p class="indent">
          3) महालेखापाल, लेखा व अनुज्ञेयता,1/2 , महाराष्ट्र, मुंबई.
        </p>
        <p class="indent">
          4) महालेखापाल, लेखा व परिक्षा, 1/2, महाराष्ट्र, मुंबई.
        </p>
        <p class="indent">
          5) मुख्य कार्यकारी अधिकारी, जिल्हा परिषद, {ZillaParishad}.
        </p>
        <p class="indent">
          6) अतिरिक्त मुख्य कार्यकारी अधिकारी, जिल्हा परिषद, {ZillaParishad}.
        </p>
        <p class="indent">
          7) मुख्य लेखा व वित्त अधिकारी, जिल्हा परिषद {ZillaParishad}.
        </p>
        <p class="indent">8) जिल्हा कोषागार अधिकारी, {ZillaParishad}.</p>
        <p class="indent">
          9) कार्यकारी अभियंता, जिल्हा परिषद (बांधकाम विभाग), {ZillaParishad}.
        </p>
        <p class="indent">
          10) निवड नस्ती (बांध-3) ग्राम विकास विभाग, बांधकाम भवन, मुंबई-1.
        </p>

        <br />
        <br />

        <div className="text-end">
          <p className="text-center fw-bold">
            {userDetail?.RoleID == "25" || userDetail?.RoleID == "24"
              ? "सयाजी पाटील"
              : userDetail?.RoleID == "40" || userDetail?.RoleID == "41"
                ? "अभिजित तेलवेकर"
                : ""}
            <br />
            कार्यासन अधिकारी, महाराष्ट्र शासन
          </p>
        </div>

        <br />
        <br />
        <br />

        {/* ================= APPENDIX 1 ================= */}
        <p class="center">
          <b>परिशिष्ट क्र. 1</b>
        </p>

        <p class="center">
          (शासन निर्णय क्र. {GRNumber}, दिनांक {GRDate})
        </p>

        <p>
          {dynamicGroups} रस्ते व पुल दुरुस्ती कार्यक्रम, सन {ProposalYear} या
          वित्तीय वर्षाकरिता {ZillaParishad} जिल्हा स्थानिक क्षेत्राचा अद्ययावत
          मंजूर कार्यक्रमाचा गोषवारा खालीलप्रमाणे आहे.
        </p>

        <p>(किंमत रु. लाखात)</p>

        {/* YOUR TABLE */}
        <table contentEditable={false} className="m-auto my-4 pdf-table">
          <thead>
            <tr>
              <th>अ. क्र.</th>
              <th>संवर्ग</th>
              <th>कामांची संख्या</th>
              <th>रक्कम</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>{GRID}</td>
              <td>{DraftList?.length}</td>
              <td>{GRAmount}</td>
            </tr>

            <tr>
              <td colSpan="2">
                <b>एकूण कामांची अंदाजित किंमत</b>
              </td>
              <td>
                <b>{DraftList?.length}</b>
              </td>
              <td>
                <b>{GRAmount}</b>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="text-end">
          <p className="text-center fw-bold">
            {userDetail?.RoleID == "25" || userDetail?.RoleID == "24"
              ? "सयाजी पाटील"
              : userDetail?.RoleID == "40" || userDetail?.RoleID == "41"
                ? "अभिजित तेलवेकर"
                : ""}
            <br />
            कार्यासन अधिकारी
          </p>
        </div>

        <br />
        <br />

        {/* ================= APPENDIX 2 ================= */}
        <p class="center">
          <b>परिशिष्ट क्र. 2</b>
        </p>

        <p>
          लेखाशिर्ष 3054-2419 रस्ते व पुल दुरुस्ती परिरक्षण कार्यक्रम अंतर्गत{" "}
          {dynamicGroups} मधील मंजूर कामांची यादी
        </p>

        <table contentEditable={false} className="m-auto my-4 pdf-table">
          <thead>
            <tr>
              <th colSpan="2" class="text-start">
                जिला {ZillaParishad}
              </th>
              <th colSpan="4">जिल्हा कोड --</th>
            </tr>
            <tr>
              <th style={{ width: "8%" }}>अ. क्र.</th>
              <th style={{ width: "30%" }}>कामाचे संक्षिप्त नांव</th>
              <th style={{ width: "18%" }}>रस्त्याचा संवर्ग व क्रमांक</th>
              <th style={{ width: "14%" }}>अंदाजित किंमत (कोटी रुपये)</th>
              <th style={{ width: "15%" }}>जॉब क्रमांक</th>
              <th className="no-print" style={{ width: "15%" }}>
                Action
              </th>
            </tr>
          </thead>
          {/* <tbody>
                        {
                            DraftList?.map((p, i) => (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{p.Work_name}</td>
                                    <td>{p.ProposalID}</td>
                                    <td>{p.Proposal_amount}</td>
                                    <td>{p.JOB_ID}</td>
                                    <td className="no-print">
                                        <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => handleRemoveProposal(p.ProposalID)}
                                        >
                                            <i className="fa fa-trash"></i> Remove
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }

                        <tr>
                            <td colspan="3"><strong>{dynamicGroups} संवर्गातील एकूण कामांची रक्कम</strong></td>
                            <td colspan="3"><strong>{GRAmount}</strong></td>
                        </tr>
                    </tbody> */}
          <tbody>
            {DraftList?.map((p, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{p.Work_name}</td>
                <td>{p.ProposalID}</td>
                {/* ✅ ADD class */}
                <td className="proposal-amount-cell">{p.Proposal_amount}</td>
                <td>{p.JOB_ID}</td>
                <td className="no-print">
                  {/* ✅ ADD data-proposal-id */}
                  <button
                    data-proposal-id={p.ProposalID}
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleRemoveProposal(p.ProposalID)}
                  >
                    <i className="fa fa-trash"></i> Remove
                  </button>
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">
                <strong>{dynamicGroups} संवर्गातील एकूण कामांची रक्कम</strong>
              </td>
              {/* ✅ ADD class */}
              <td colSpan="3" className="gr-total-cell">
                <strong>{GRAmount}</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="text-end">
          <p className="text-center fw-bold">
            {userDetail?.RoleID == "25" || userDetail?.RoleID == "24"
              ? "सयाजी पाटील"
              : userDetail?.RoleID == "40" || userDetail?.RoleID == "41"
                ? "अभिजित तेलवेकर"
                : ""}
            <br />
            कार्यासन अधिकारी
          </p>
        </div>
      </div>
    );
  };

  const renderGR = () => {
    if (selectedHeadCode == "2515-1238(MLA Representative)") {
      return <GR2515Template grData={grData} DraftList={DraftList} />;
    }

    if (
      selectedHeadCode ==
      "3054-2419(Roads and bridge repair maintenance program)"
    ) {
      return <GR3054Template grData={grData} DraftList={DraftList} />;
    }

    return <p>No Template Found</p>;
  };
  const marathiNames = {
    "Satyajit Patil": "सयाजी पाटील",
    "Rahul Shinde": "राहुल शिंदे",
    "Abhijit Telvekar": "अभिजित तेलवेकर",
    "State-2515-RDD Checker(ASO)": "राज्य-2515-आरडीडी तपासनीस",
    "State-RDD Checker(ASO)": "राज्य-आरडीडी तपासनीस",
  };

  const getUniqueExportBills = () => {
    const source = Array.isArray(filteredBills) ? filteredBills : [];

    return source.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.GRID === item.GRID),
    );
  };

  const formatExportDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString();
  };

  const exportGRDraftListToExcel = async (filename = "GR_Draft_List.xlsx") => {
    const exportBills = getUniqueExportBills();

    if (!exportBills.length) {
      alert("No data available");
      return;
    }

    setLoading(true);

    try {
      const showHeadCode =
        userDetail?.Role !== "RDD Section Officer" &&
        userDetail?.Role !== "RDD Checker(ASO)";

      let totalGRAmount = 0;

      const excelData = exportBills.map((project, index) => {
        const amount = Number(project.GRAmount || 0);

        totalGRAmount += Number.isNaN(amount) ? 0 : amount;

        return {
          "Sr.No.": index + 1,

          "GR Number": project.GRNumber || "-",

          GRID: project.GRID || "-",

          ...(showHeadCode
            ? {
                HeadCode: project.HeadCode || "-",
              }
            : {}),

          "Proposal Year": project.ProposalYear || "-",

          "Zilla Parishad": project.ZillaParishad || "-",

          "GR Amount": amount,

          "GR Date": formatExportDate(project.GRDate),

          "Edit By": project.EditedBy || "No One",

          "Uploaded By": project.Uploadedby || "No One",
        };
      });

      // TOTAL ROW
      excelData.push({
        "Sr.No.": "",
        "GR Number": "",
        GRID: "",

        ...(showHeadCode
          ? {
              HeadCode: "",
            }
          : {}),

        "Proposal Year": "",

        "Zilla Parishad": "TOTAL AMOUNT",

        "GR Amount": totalGRAmount,

        "GR Date": "",

        "Edit By": "",

        "Uploaded By": "",
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // Column widths
      worksheet["!cols"] = Object.keys(excelData[0]).map((key) => {
        const maxLength = Math.max(
          key.length,

          ...excelData.map((row) => String(row[key] ?? "").length),
        );

        return {
          wch: Math.min(Math.max(maxLength + 2, 14), 35),
        };
      });

      // Freeze header
      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1,
      };

      // Filter only actual data rows
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: {
            r: 0,
            c: 0,
          },

          e: {
            r: excelData.length - 2,

            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "GR Draft List");

      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("GR Draft List Excel Export Error:", error);

      alert("Failed to export Excel.");
    } finally {
      setLoading(false);
    }
  };

  const downloadGRDraftListAsPDF = async (
    tableClass = "GRDraftListTable",
    filename = "GR_Draft_List.pdf",
    title = "GR Draft List",
  ) => {
    const exportBills = getUniqueExportBills();

    if (!exportBills.length) {
      alert("No data available");
      return;
    }

    setExportingPDF(true);
    setLoading(true);

    try {
      const showHeadCode =
        userDetail?.Role !== "RDD Section Officer" &&
        userDetail?.Role !== "RDD Checker(ASO)";

      // ✅ Single source of truth for column order — header and body always match
      const columns = [
        { label: "Sr.No.", key: "srNo" },
        { label: "GR Number", key: "GRNumber" },
        { label: "GRID", key: "GRID" },
        ...(showHeadCode ? [{ label: "HeadCode", key: "HeadCode" }] : []),
        { label: "Proposal Year", key: "ProposalYear" },
        { label: "Zilla Parishad", key: "ZillaParishad" },
        { label: "GR Amount", key: "GRAmount" },
        { label: "GR Date", key: "GRDate" },
        { label: "Edit By", key: "EditedBy" },
        { label: "Uploaded By", key: "Uploadedby" },
      ];

      const grAmountIndex = columns.findIndex((c) => c.key === "GRAmount");

      // Build export table from scratch (no dependency on live table styling)
      const exportTable = document.createElement("table");
      exportTable.style.borderCollapse = "collapse";
      exportTable.style.width = "max-content";
      exportTable.style.background = "#ffffff";
      exportTable.style.color = "#000000";
      exportTable.style.fontSize = "11px";

      // Header
      const thead = document.createElement("thead");
      const headRow = document.createElement("tr");
      columns.forEach((col) => {
        const th = document.createElement("th");
        th.textContent = col.label;
        th.style.padding = "8px";
        th.style.border = "1px solid #ccc";
        th.style.background = "#2C78DB"; // ✅ explicit bg, no reliance on parent
        th.style.color = "#ffffff"; // ✅ visible against its own bg
        th.style.whiteSpace = "nowrap";
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      exportTable.appendChild(thead);

      // Body
      const tbody = document.createElement("tbody");
      let total = 0;

      exportBills.forEach((project, index) => {
        const amount = Number(project.GRAmount) || 0;
        total += amount;

        const row = document.createElement("tr");
        const rowData = {
          srNo: index + 1,
          GRNumber: project.GRNumber || "-",
          GRID: project.GRID || "-",
          HeadCode: project.HeadCode || "-",
          ProposalYear: project.ProposalYear || "-",
          ZillaParishad: project.ZillaParishad || "-",
          GRAmount: project.GRAmount ?? "-",
          GRDate: project.GRDate ? String(project.GRDate).split("T")[0] : "-",
          EditedBy: project.EditedBy || "No One",
          Uploadedby: project.Uploadedby || "No One",
        };

        columns.forEach((col) => {
          const td = document.createElement("td");
          td.textContent = String(rowData[col.key]);
          td.style.padding = "8px";
          td.style.border = "1px solid #ccc";
          row.appendChild(td);
        });

        tbody.appendChild(row);
      });

      // ✅ Total row — label spans everything before GR Amount, total sits exactly under GR Amount
      const totalRow = document.createElement("tr");

      const totalLabel = document.createElement("td");
      totalLabel.textContent = "TOTAL AMOUNT";
      totalLabel.colSpan = grAmountIndex;
      totalLabel.style.fontWeight = "bold";
      totalLabel.style.padding = "8px";
      totalLabel.style.border = "1px solid #ccc";
      totalRow.appendChild(totalLabel);

      const totalAmountCell = document.createElement("td");
      totalAmountCell.textContent = total.toString();
      totalAmountCell.style.fontWeight = "bold";
      totalAmountCell.style.padding = "8px";
      totalAmountCell.style.border = "1px solid #ccc";
      totalRow.appendChild(totalAmountCell);

      const trailingCols = columns.length - grAmountIndex - 1;
      if (trailingCols > 0) {
        const spacer = document.createElement("td");
        spacer.colSpan = trailingCols;
        spacer.style.border = "1px solid #ccc";
        totalRow.appendChild(spacer);
      }

      tbody.appendChild(totalRow);
      exportTable.appendChild(tbody);

      // Position off-screen for html2canvas capture
      exportTable.style.position = "absolute";
      exportTable.style.left = "-99999px";
      exportTable.style.top = "0";
      exportTable.style.zIndex = "-1";
      document.body.appendChild(exportTable);

      await new Promise((resolve) => setTimeout(resolve, 100));

      // Landscape A4
      const pdf = new jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const topMargin = 18;
      const sideMargin = 8;
      const bottomMargin = 10;

      pdf.setFontSize(15);
      pdf.setFont("helvetica", "bold");
      pdf.text(title, pageWidth / 2, 10, { align: "center" });

      const canvas = await html2canvas(exportTable, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#ffffff",
        windowWidth: exportTable.scrollWidth,
      });

      const imgWidth = pageWidth - sideMargin * 2;
      const pxToMm = imgWidth / canvas.width;
      const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
      const usablePageHeightPx = usablePageHeightMm / pxToMm;

      let renderedHeight = 0;
      let pageNumber = 0;

      while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(
          usablePageHeightPx,
          canvas.height - renderedHeight,
        );

        const pageCanvas = document.createElement("canvas");
        const context = pageCanvas.getContext("2d");
        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;

        context.drawImage(
          canvas,
          0,
          renderedHeight,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight,
        );

        const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

        if (pageNumber > 0) pdf.addPage();
        pdf.addImage(
          imgData,
          "JPEG",
          sideMargin,
          topMargin,
          imgWidth,
          sliceHeight * pxToMm,
        );

        renderedHeight += sliceHeight;
        pageNumber++;
      }

      pdf.save(filename);
      document.body.removeChild(exportTable);
    } catch (error) {
      console.error("GR Draft List PDF Export Error:", error);
      alert("Failed to export PDF.");
    } finally {
      setExportingPDF(false);
      setLoading(false);
    }
  };
  return (
    <>
      <style>
        {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #007bff",
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              animation: "spin 1s linear infinite",
            }}
          />
          <style>
            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
          </style>
        </div>
      )}

      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        {showmenu === 1 && (
          <div className="col-11 m-auto">
            <div className='col-12 px-4 mb-2 mt-3'>
                                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
                                    <h5 className='my-auto fw-bold'>
                                        <img src="/Work-Order-Management-Blue64.png" alt="Progress List" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                        <span className='my-auto '>{t("GR Draft List")}</span>
                                    </h5>
<div className="d-flex gap-2">
    <button
        className="btn btn-success"
        onClick={() =>
            exportTableByClassToExcel(
                uniqueBills,
                "GR_Draft_List.xlsx"
            )
        }
    >
        {t("Download Excel")}
    </button>

    <button
        className="btn btn-danger"
        onClick={() =>
            downloadTableOnlyAsPDF(
                "GRDraftTable",
                "GR_Draft_List.pdf",
                "GR Draft List Report"
            )
        }
    >
        {t("Download PDF")}
    </button>
</div>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "nowrap" }}>
                                    {/* Financial Year filter */}
                                    <select
                                        value={selectedFinancialYear}
                                        onChange={(e) => {
                                            console.log("Selected FY:", e.target.value);
                                            setSelectedFinancialYear(e.target.value);
                                        }}
                                        style={{
                                            width: "180px",
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                            fontSize: "14px",
                                        }}
                                    >
                                        <option value="">All Financial Years</option>
                                        {goingYear.map((year, index) => (
                                            <option key={index} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>

{/* Added for department */}
  {myDepartments.length > 1 && (
  <select
    value={selectedDepartment}
    onChange={(e) => setSelectedDepartment(e.target.value)}
    style={{
      width: "200px",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      fontSize: "14px",
    }}
  >
    <option value="">{t("Select Department")}</option>
    {myDepartments.map((d) => (
      <option key={d.id} value={d.id}>
        {d.name}
      </option>
    ))}
  </select>
)}



                                    {/* Zilla Parishad filter */}
                                    <select
                                        value={selectedZillaParishad}
                                        onChange={(e) => setSelectedZillaParishad(e.target.value)}
                                        style={{
                                            width: "180px",
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "8px",
                                            fontSize: "14px",
                                        }}
                                    >
                                        <option value="">{t("All Zilla Parishad")}</option>
                                        {zillaParishadList.map((zp, index) => (
                                            <option key={index} value={zp}>
                                                {zp}
                                            </option>
                                        ))}
                                    </select>

                                    {/* Search */}
                                    <div style={{ position: "relative", width: "250px" }}>
                                        <img
                                            src="/Search32.png"
                                            alt="Search Icon"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "10px",
                                                transform: "translateY(-50%)",
                                                width: "16px",
                                                height: "16px",
                                                opacity: 0.6
                                            }}
                                        />
                                        <input
                                            type="text"
                                            placeholder={t("Search Here")}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            value={searchTerm}
                                            style={{
                                                width: "100%",
                                                padding: "8px 12px 8px 32px",
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                                backgroundColor: "#f1f6fc",
                                                fontSize: "14px",
                                                color: "#333",
                                                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                outline: "none"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

            {/* --> old code */}
            {/* <div className="col-12 ">
              <div
                className="col-12 px-4 mb-4 mt-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <h5 className="my-auto fw-bold">
                  <img
                    src="/Work-Order-Management-Blue64.png"
                    alt="Progress List"
                    style={{
                      width: "24px",
                      height: "24px",
                    }}
                    className="my-auto me-1"
                  />

                  <span className="my-auto">{t("GR Draft List")}</span>
                </h5>

                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <div style={{ position: "relative", width: "150px", marginRight: "10px" }}>
                                            <select
                                                value={selectedDistrict}
                                                onChange={(e) => setSelectedDistrict(e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px 12px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#f1f6fc",
                                                    fontSize: "14px",
                                                    color: "#333",
                                                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                    outline: "none",
                                                }}
                                            >
                                                <option value="">{t("All Zilla Parishad")}</option>
                                                {districtOptions.map((district, index) => (
                                                    <option key={index} value={district}>
                                                        {district}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                  <div
                    style={{
                      position: "relative",
                      width: "250px",
                    }}
                  >
                    <img
                      src="/Search32.png"
                      alt="Search Icon"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        width: "16px",
                        height: "16px",
                        opacity: 0.6,
                      }}
                    />

                    <input
                      type="text"
                      placeholder={t("Search Here")}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      value={searchTerm}
                      style={{
                        width: "100%",
                        padding: "8px 12px 8px 32px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f1f6fc",
                        fontSize: "14px",
                        color: "#333",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                        outline: "none",
                      }}
                    />
                  </div>

                  <button
                    className="btn btn-success"
                    disabled={loading}
                    onClick={() =>
                      exportGRDraftListToExcel("GR_Draft_List.xlsx")
                    }
                  >
                    {t("Download Excel")}
                  </button>

                  <button
                    className="btn btn-danger"
                    disabled={loading || exportingPDF}
                    onClick={() =>
                      downloadGRDraftListAsPDF(
                        "GRDraftListTable",
                        "GR_Draft_List.pdf",
                        "GR Draft List",
                      )
                    }
                  >
                    {t("Download PDF")}
                  </button>
                </div>
              </div>
            </div> */}
            <div className="col-12 pb-5">
              <div className="col-12 pb-5">
                <div
                  className="col-12 mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative"  }}
                  >
                    <table
                      className="m-0 p-0 GRDraftTable"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10}}>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "18px",
                          }}
                        >
                          <th style={{ minWidth: "60px", padding: "8px" }}>
                            {t("Sr.no.")}
                          </th>
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("GR Number")}
                          </th>
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("GRID")}
                          </th>
                          {userDetail.Role == "RDD Section Officer" ||
                          userDetail.Role == "RDD Checker(ASO)" ? (
                            ""
                          ) : (
                            <th style={{ minWidth: "180px", padding: "8px" }}>
                              {t("HeadCode")}
                            </th>
                          )}
                          {/* <th >Proposal ID</th> */}
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("Proposal Year")}
                          </th>
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("Zilla Parishad")}
                          </th>
                          {/* <th >Proposal Amount</th> */}
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("GR Amount")}
                          </th>
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("GR Date")}
                          </th>
                          <th style={{ minWidth: "180px", padding: "8px" }}>
                            {t("GR Approval Copy")}
                          </th>
                          <th style={{ minWidth: "180px", padding: "8px" }}>
                            {t("Edit By")}
                          </th>
                          {/* <th style={{ width: "10%" }} >View</th> */}
                          <th style={{ minWidth: "130px", padding: "8px" }}>
                            {t("Edit View")}
                          </th>
                          <th style={{ minWidth: "180px", padding: "8px" }}>
                            {t("Uploaded By")}
                          </th>
                          <th style={{ minWidth: "170px", padding: "8px" }}>
                            {t("Final GR")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentBills?.length === 0 ? (
                          <tr>
                            <td
                              colSpan="30"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          currentBills
                            .filter(
                              (item, index, self) =>
                                index ===
                                self.findIndex((t) => t.GRID === item.GRID),
                            )
                            .map((project, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                              const userRole = userDetail?.Role;
                              let uploadedRoles = [];

                              try {
                                uploadedRoles =
                                  typeof project.UploadedRoles === "string"
                                    ? JSON.parse(project.UploadedRoles)
                                    : Array.isArray(project.UploadedRoles)
                                      ? project.UploadedRoles
                                      : [];
                              } catch {
                                uploadedRoles = [];
                              }

                              console.log("uploadedRole ---> ", uploadedRoles);

                              const isDisabled =
                                uploadedRoles?.includes(userRole);

                              return (
                              
                                  <tr
                                    className="px-3"
                                    key={index}
                                    style={{
                                      borderBottom: "1px solid #3b409e",
                                      backgroundColor: bgColor,
                                      fontSize: "18px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    <td style={{ padding: "8px 8px" }}>
                                      {indexOfFirstBill + index + 1}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {project.GRNumber}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {project.GRID}
                                    </td>
                                    {userDetail.Role == "RDD Section Officer" ||
                                    userDetail.Role == "RDD Checker(ASO)" ? (
                                      ""
                                    ) : (
                                      <td style={{ padding: "8px 8px" }}>
                                        {project.HeadCode}
                                      </td>
                                    )}
                                    {/* <td >{project.ProposalID}</td> */}
                                    <td style={{ padding: "8px 8px" }}>
                                      {project.ProposalYear}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {project.ZillaParishad}
                                    </td>
                                    {/* <td >{project.ProposalAmount}</td> */}
                                    <td style={{ padding: "8px 8px" }}>
                                      {formatIndianAmount(project.GRAmount)}
                                    </td>
                                    <td style={{ padding: "8px 8px" }}>
                                      {/* {project.GRDate?.split("T")[0].replace(
                                        " ",
                                      )} */}
                                      {formatDate(project.GRDate)}
                                    </td>

                                    <td
                                      style={{
                                        maxWidth: "120px",
                                        padding: "8px",
                                        wordWrap: "break-word",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      {project.DraftName ? (
                                        <a
                                          href={`${apiurl}/GRDraftCopy/${project.DraftName}`}
                                          target="_blank"
                                        >
                                          {project.DraftName}
                                        </a>
                                      ) : project.GRDraftCopy ? (
                                        <a
                                          href={`${apiurl}/GRDraftCopy/${project.GRDraftCopy}`}
                                          target="_blank"
                                        >
                                          {project.GRDraftCopy}
                                        </a>
                                      ) : (
                                        <p className="text-danger my-auto fw-bold">
                                          {t("No Copy")}
                                        </p>
                                      )}
                                    </td>

                                    <td style={{ padding: "8px 8px" }}>
                                      {project.EditedBy ? (
                                        <p className="text-black my-auto fw-bold">
                                          {project.EditedBy}
                                        </p>
                                      ) : (
                                        <p className="text-danger my-auto fw-bold">
                                          {t("No One")}
                                        </p>
                                      )}
                                    </td>

                                    <td
                                      style={{
                                        height: "3rem",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => {
                                          getDraftlistbygeidwise(project.GRID);
                                          setShowmenu(2);
                                        }}
                                      >
                                        {t("Edit Draft")}
                                      </button>
                                    </td>

                                    <td style={{ padding: "8px 8px" }}>
                                      {project.Uploadedby ? (
                                        <p className="text-black my-auto fw-bold">
                                          {project.Uploadedby}
                                        </p>
                                      ) : (
                                        <p className="text-danger my-auto fw-bold">
                                          {t("No One")}
                                        </p>
                                      )}
                                    </td>

                                    <td className="py-2">
                                      <button
                                        onClick={() =>
                                          nav(`/AdminDashboard/UpdateGRDraft`, {
                                            state: {
                                              id: project.GRID,
                                            },
                                          })
                                        }
                                        className="m-auto text-center"
                                        style={{
                                          width: "70%",
                                          fontWeight: "600",
                                          padding: "7px 3px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "0.1rem",
                                          background: isDisabled
                                            ? "gray"
                                            : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                          cursor: isDisabled
                                            ? "not-allowed"
                                            : "pointer",
                                        }}
                                        disabled={isDisabled}
                                      >
                                        {t("Upload Draft")}
                                      </button>
                                    </td>
                                  </tr>
                                        );
                                                    })
                                                )}
                                  <tr
                                    style={{
                                      backgroundColor: "#ffffff",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                    }}
                                  >
                                    <td
                                      colSpan={5}
                                      style={{
                                        textAlign: "right",
                                        padding: "10px",
                                      }}
                                    >
                                      Page Total 
                                    </td>

                                    {/* Total Bill Amount */}
                                    <td style={{ padding: "10px" }}>
                                      ₹{" "}
                                      {currentBills
                                        .reduce(
                                          (sum, item) =>
                                            sum + Number(item.GRAmount || 0),
                                          0,
                                        )
                                        .toLocaleString("en-IN")}
                                    </td>

                                    {/* Total Net Payable Amount */}

                                    {/* Empty remaining columns */}
                                    <td colSpan={6}></td>
                                  </tr>
                                  <tr
                                    style={{
                                      backgroundColor: "#ffffff",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                    }}
                                  >
                                    <td
                                      colSpan={5}
                                      style={{
                                        textAlign: "right",
                                        padding: "10px",
                                      }}
                                    >
                                      Gross Total
                                    </td>

                                    {/* Total Bill Amount */}
                                    <td style={{ padding: "10px" }}>
                                      ₹{" "}
                                      {filteredBills
                                        .reduce(
                                          (sum, item) =>
                                            sum + Number(item.GRAmount || 0),
                                          0,
                                        )
                                        .toLocaleString("en-IN")}
                                    </td>

                                    {/* Total Net Payable Amount */}

                                    {/* Empty remaining columns */}
                                    <td colSpan={6}></td>
                                  </tr>
                                
                        
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div></div>

                    {/*this is showing page option */}
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "25px 0",
                      }}
                    >
                      <div>
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "18px", margin: 0 }}
                        >
                          {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                          {Math.min(indexOfLastBill, uniqueBills.length)}{" "}
                          {t("of")} {uniqueBills.length} {t("entries")}
                        </p>
                      </div>

                      <div style={{ display: "flex" }}>
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* {

                    showmenu === 2 &&
                    <div className="col-12 DraftContainer my-5 ">
                        <div className="my-4 mx-5" style={{ position: "relative" }}>
                            <button

                                className="btn btn-danger px-20 py-20"
                                onClick={() => { setShowmenu(1); setSelectedGRID(null) }}><i className="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
                        </div>
                        <div className="col-10 m-auto border border-dark p-2" id="draftContent">

                            first page 
                            <div className="col-12">



                                <EditableBlock onEdit={() => setIsEdited(true)}>
                                    {renderGR()}
                                </EditableBlock>





                            </div>



                        </div>

                        <div className="col-4 m-auto my-3 text-center">
                            <button onClick={() => downloadDivAsPDF('draftContent')} className="btn btn-primary m-3">
                                Download Editted PDF
                            </button>
                            <button className='btn btn-danger px-5' onClick={() => { setShowmenu(1); setSelectedGRID(null) }}>Close</button>
                        </div>
                    </div >
                } */}

        {showmenu === 2 && (
          <div className="col-12 DraftContainer my-5">
            <div className="my-4 mx-5">
              <button
                className="btn btn-danger px-20 py-20"
                onClick={() => {
                  setShowmenu(1);
                  setSelectedGRID(null);
                  setGrInitialized(false);
                }}
              >
                <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
              </button>
            </div>

            <div className="col-10 m-auto border border-dark p-2">
              <div className="col-12">
                {/* KEY: ref div is EMPTY here Content is injected via useEffect → innerHTML React NEVER re-renders inside this div All user edits are preserved permanently  */}
                <div
                  ref={grContentRef}
                  contentEditable={true}
                  suppressContentEditableWarning={true}
                  style={{
                    outline: "1px dashed gray",
                    padding: "4px",
                    marginBottom: "10px",
                    minHeight: "200px",
                  }}
                  onInput={() => setIsEdited(true)}
                />
                {/* ✅ NO children here — innerHTML set by useEffect */}
              </div>
            </div>

            <div className="col-4 m-auto my-3 text-center">
              <button
                onClick={() => downloadDivAsPDF()}
                className="btn btn-primary m-3"
              >
                Download Edited PDF
              </button>
              <button
                className="btn btn-danger px-5"
                onClick={() => {
                  setShowmenu(1);
                  setSelectedGRID(null);
                  setGrInitialized(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default GRDraftList;
